import { Autocomplete, Box, Checkbox, FormControl, Grid, ListItemText, MenuItem, Select, TextField, Typography } from '@mui/material'
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import React from 'react'
import PhoneInput from 'react-phone-input-2';
import SignatureCanvas from 'react-signature-canvas';
import { defaultLabel, smallLabel, subSection } from '../constant/material_style';
import CurrencyInput from 'react-currency-input-field';
import moment from 'moment';
import { Controller } from 'react-hook-form';
import { getImageUrl } from '../api/rc_admission_form';
import useSWR from 'swr'
import { Spinner } from 'reactstrap';
import { FaCheckCircle } from "react-icons/fa";

const CustomTextfield = ({
        label, formValue, onChangeVal, name, typeOfField, selectLists, errors, disableFuture,
        disablePast, minRow, sigCanvas, saveSignature, clearSignature, small, subsection,
        readOnly = false, control, regexType, marker, savedSignature, isAdmin = false, showPlaceholder = true
    }) => {

    const getImage = async (url) => {
        if(url && url !== '' ) {
            const data = await getImageUrl(url);
            return data;
        }
        return null;
    }

    const SignatureImageComponent = ({ formValue }) => {
        const { data: imageUrl, error } = useSWR(formValue, getImage);

        if(formValue === "") return null;
        if (error) return <div>Failed to load image</div>;
        if (!imageUrl) return <Spinner />;

        return (
            <Grid item xs={12} sm={6} md={4.5}>
                <Box>
                    <img
                        src={imageUrl}
                        alt="signature"
                        style={{ border: '1px solid #ccc', borderRadius: '8px', width: '100%', height: 'auto' }}
                    />
                </Box>
            </Grid>
        );
    };

    switch (typeOfField) {
        case 'text1':
            return (
                <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} md={small ? 4 : 3}>
                        { subsection ? (
                            <Typography style={small ? subSection : defaultLabel}>{label}</Typography>
                        ) : (
                            <Typography style={small ? smallLabel : defaultLabel}>{label}</Typography>
                        )}
                    </Grid>
                    <Grid item xs={subsection ? 11 : 12} md={small ? 7 : 8}>
                        <Controller
                            control={control}
                            name={name}
                            defaultValue={formValue}
                            watch
                            render={({
                                field: { onChange, value },
                            }) => (
                                <TextField
                                    fullWidth
                                    //value={formValue}
                                    value={value ?? ''}
                                    // error={!!errors[name]}
                                    // helperText={errors[name]?.message}
                                    variant="outlined"
                                    className='rc_form_field'
                                    InputLabelProps={{ shrink: true }}
                                    sx={{
                                        '& .MuiOutlinedInput-root input': {
                                            padding: '8px 15px',
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            marginBottom: '10px',
                                            borderRadius: '30px',
                                            marginLeft: subsection ? '16px' : '0px',
                                            fontSize: small && '12px',
                                            backgroundColor: readOnly && '#ededed',
                                        },
                                    }}
                                    onChange={(e) => {
                                        const field_value = e.target.value;
                                        const inputValue = field_value.replace(regexType, '');
                                        onChange(inputValue);
                                        onChangeVal(name, inputValue);
                                    }}
                                    InputProps={{ readOnly: readOnly }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                        }
                                    }}
                                    placeholder={isAdmin && showPlaceholder? "Staff Input": ""}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            );

        case 'text':
            return (
                <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} md={small ? 4 : 3}>
                        { subsection ? (
                            <Typography style={small ? subSection : defaultLabel}>{label}</Typography>
                        ) : (
                            <Typography style={small ? smallLabel : defaultLabel}>{label}</Typography>
                        )}
                    </Grid>
                    <Grid item xs={subsection ? 11 : 12} md={small ? 7 : 8}>
                        <TextField
                            name={name}
                            fullWidth
                            value={formValue}
                            variant="outlined"
                            sx={{
                                '& .MuiOutlinedInput-root input': {
                                    padding: '8px 15px',
                                },
                                '& .MuiOutlinedInput-root': {
                                    marginBottom: '10px',
                                    borderRadius: '30px',
                                    marginLeft: subsection ? '16px' : '0px',
                                    fontSize: small && '12px',
                                    backgroundColor: readOnly && '#ededed'
                                },
                            }}
                            onChange={(e) => onChangeVal(name, e.target.value)}
                            InputProps={{ readOnly: readOnly }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  e.preventDefault();
                                }
                            }}
                            placeholder={isAdmin && showPlaceholder? "Staff Input": ""}
                        />
                    </Grid>
                </Grid>
            );

        case 'multilineText1':
            return (
                <Grid container alignItems="center" spacing={1}>
                    <Grid item md={small ? 3 : 1.8}>
                        <Typography style={small ? smallLabel : defaultLabel}>{label}</Typography>
                    </Grid>
                    <Grid item xs={12} md={small ? 7.8 : 7}>
                        <Controller
                            control={control}
                            name={name}
                            defaultValue={formValue}
                            render={({
                                field: { onChange, value },
                            }) => (
                                <TextField
                                    name={name}
                                    fullWidth
                                    value={value ?? ''}
                                    multiline
                                    minRows={minRow}
                                    variant="outlined"
                                    sx={{
                                        '& .MuiOutlinedInput-root input': {
                                            padding: '8px 15px',
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            marginBottom: '10px',
                                            borderRadius: '30px',
                                            marginLeft: subsection ? '16px' : '0px',
                                            fontSize: small && '12px',
                                            wordWrap: 'break-word',
                                            whiteSpace: 'pre-wrap',
                                            backgroundColor: readOnly && '#ededed'
                                        },
                                    }}
                                    InputProps={{ readOnly: readOnly }}
                                    onChange={(e) => {
                                        onChange(e.target.value);
                                        onChangeVal(name, e.target.value);
                                    }}
                                    placeholder={isAdmin && showPlaceholder? "Staff Input": ""}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            );

        case 'multilineText':
            return (
                <Grid container alignItems="center" spacing={1}>
                    <Grid item md={small ? 3 : 1.5}>
                        <Typography style={small ? smallLabel : defaultLabel}>{label}</Typography>
                    </Grid>
                    <Grid item xs={12} md={small ? 7.8 : 10}>
                        <TextField
                            name={name}
                            fullWidth
                            value={formValue}
                            multiline
						    minRows={minRow}
                            variant="outlined"
                            sx={{
                                '& .MuiOutlinedInput-root input': {
                                    padding: '8px 15px',
                                },
                                '& .MuiOutlinedInput-root': {
                                    marginBottom: '10px',
                                    borderRadius: '30px',
                                    marginLeft: subsection ? '16px' : '0px',
                                    fontSize: small && '12px',
                                    wordWrap: 'break-word',
                                    whiteSpace: 'pre-wrap',
                                    backgroundColor: readOnly && '#ededed'
                                },
                            }}
                            InputProps={{ readOnly: readOnly }}
                            onChange={(e) => onChangeVal(name, e.target.value)}
                            placeholder={isAdmin? "Staff Input": ""}
                        />
                    </Grid>
                </Grid>
            );

        case 'phone1':
            return (
                <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} md={small ? 4 : 3}>
                        { subsection ? (
                            <Typography style={small ? subSection : defaultLabel}>{label}</Typography>
                        ) : (
                            <Typography style={small ? smallLabel : defaultLabel}>{label}</Typography>
                        )}
                    </Grid>
                    <Grid item xs={subsection ? 11 : 12} md={small ? 7 : 8}>
                        <Controller
                            control={control}
                            name={name}
                            defaultValue={formValue}
                            render={({
                                field: { onChange, value },
                            }) => (
                                <PhoneInput
                                    name={name}
                                    countryCodeEditable={false}
                                    country={'my'}
                                    international
                                    countryCallingCodeEditable={false}
                                    value={value ?? ''}
                                    onChange={(value, country) => {
                                        const countryCode = country.countryCode;
                                        const reducedPhone = value.slice(countryCode.length);
                                        const phoneNum = `+${country.dialCode}-${reducedPhone}`;

                                        onChange(phoneNum);
                                        onChangeVal(name, phoneNum)
                                    }}
                                    enableSearch
                                    containerStyle={{
                                        width: '100%',
                                        marginLeft: subsection && '16px',
                                    }}
                                    inputStyle={{
                                        fontSize: small && '12px',
                                    }}
                                    
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            );

        case 'phone':
            return (
                <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} md={small ? 4 : 3}>
                        { subsection ? (
                            <Typography style={small ? subSection : defaultLabel}>{label}</Typography>
                        ) : (
                            <Typography style={small ? smallLabel : defaultLabel}>{label}</Typography>
                        )}
                    </Grid>
                    <Grid item xs={subsection ? 11 : 12} md={small ? 7 : 8}>
                        <PhoneInput
                            name={name}
                            countryCodeEditable={false}
                            country={'my'}
                            international
                            countryCallingCodeEditable={false}
                            value={formValue}
                            onChange={(value) => {
                                if (value) {
                                    value = value.replace(/^60/, '+60-');
                                }
                                onChangeVal(name, value)
                            }}
                            enableSearch
                            containerStyle={{
                                width: '100%',
                                marginLeft: subsection && '16px'
                            }}
                            inputStyle={{
                                fontSize: small && '12px',
                                background: readOnly ? '#ededed' : 'white'
                            }}
                            disabled={readOnly}
                        />
                    </Grid>
                </Grid>
            );

        case 'number':
            return (
                <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} md={small ? 4 : 3}>
                        { subsection ? (
                            <Typography style={small ? subSection : defaultLabel}>{label}</Typography>
                        ) : (
                            <Typography style={small ? smallLabel : defaultLabel}>{label}</Typography>
                        )}
                    </Grid>
                    <Grid item xs={12} md={small ? 7 : 8}>
                        <Controller
                            control={control}
                            name={name}
                            defaultValue={formValue}
                            render={({
                                field: { onChange, value },
                            }) => (
                                <TextField
                                    name={name}
                                    type='number'
                                    value={value ?? ''}
                                    fullWidth
                                    // error={!!errors.residentWeight}
                                    // helperText={errors.residentWeight}
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                    sx={{
                                        '& .MuiOutlinedInput-root input': {
                                            padding: '8px 15px',
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            marginBottom: '10px',
                                            borderRadius: '30px',
                                            marginLeft: subsection ? '16px' : '0px',
                                            fontSize: small && '12px'
                                        },
                                    }}
                                    onChange={(e) => {
                                        const inputValue = e.target.value;
                                        if(regexType.test(inputValue)) {
                                            onChange(inputValue);
                                            onChangeVal(name, inputValue);
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                        e.preventDefault();
                                        }
                                    }}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            );

        case 'select':
            return(
                <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} md={small ? 4 : 3}>
                        { subsection ? (
                            <Typography style={small ? subSection : defaultLabel}>{label}</Typography>
                        ) : (
                            <Typography style={small ? smallLabel : defaultLabel}>{label}</Typography>
                        )}
                    </Grid>
                    <Grid item xs={12} md={small ? 7 : 8}>
                        <FormControl sx={{ width: '100%', borderRadius: '30px' }}>
                            <Select
                                name={name}
                                className={small ? 'custom-small-select' : 'custom-select'}
                                value={formValue}
                                onChange={(e) => onChangeVal(name, e.target.value)}
                                displayEmpty
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                      e.preventDefault();
                                    }
                                }}
                            >
                                { selectLists.map((val, index) => (
                                    <MenuItem value={val} key={index}>{val}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            );

        case 'autoComplete':
            return (
                <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} md={small ? 4 : 3}>
                        { subsection ? (
                            <Typography style={small ? subSection : defaultLabel}>{label}</Typography>
                        ) : (
                            <Typography style={small ? smallLabel : defaultLabel}>{label}</Typography>
                        )}
                    </Grid>
                    <Grid item xs={12} md={small ? 7 : 8}>
                        <FormControl sx={{ width: '100%', borderRadius: '30px' }}>
                            <Controller
                                control={control}
                                name={name}
                                defaultValue={formValue}
                                render={({
                                    field: { onChange, value },
                                }) => (
                                    <Autocomplete
                                        name={name}
                                        className='custom-autofield'
                                        value={value ?? ''}
                                        onInputChange={(e, inputVal) => {
                                            onChange(inputVal);
                                            onChangeVal(name, inputVal);
                                        }}
                                        options={selectLists}
                                        freeSolo
                                        renderInput={(params) => (
                                            <TextField {...params} placeholder={isAdmin && showPlaceholder? " Staff Input" : ""}/>
                                        )}
                                        getOptionLabel={(option) => option}
                                        renderOption={(props, option) => (
                                            <li {...props} key={option}>
                                                {option}
                                            </li>
                                        )}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                            }
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root input': {
                                                padding: '8px 15px',
                                            },
                                            '& .MuiOutlinedInput-root': {
                                                marginBottom: '10px',
                                                borderRadius: '30px',
                                                marginLeft: subsection ? '16px' : '0px',
                                                fontSize: small ? '12px' : '16px',
                                                backgroundColor: readOnly && '#ededed',
                                            },
                                        }}
                                        readOnly={readOnly}
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            );

            case 'select1':
                return(
                    <Grid container alignItems="center" spacing={1}>
                        <Grid item xs={12} md={small ? 4 : 3}>
                            { subsection ? (
                                <Typography style={small ? subSection : defaultLabel}>{label}</Typography>
                            ) : (
                                <Typography style={small ? smallLabel : defaultLabel}>{label}</Typography>
                            )}
                        </Grid>
                        <Grid item xs={12} md={small ? 7 : 8}>
                            <FormControl sx={{ width: '100%', borderRadius: '30px' }}>
                                <Controller
                                    control={control}
                                    name={name}
                                    defaultValue={formValue}
                                    render={({
                                        field: { onChange, value }
                                    }) => (
                                        <Select
                                            name={name}
                                            className={small ? 'custom-small-select' : 'custom-select'}
                                            value={value ?? ""}
                                            onChange={(e) => {
                                                const selectedVal = e.target.value;
                                                onChange(selectedVal)
                                                onChangeVal(name, selectedVal);
                                            }}
                                            displayEmpty
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                }
                                            }}
                                            style={{backgroundColor: readOnly && '#ededed', color: value? "black" : "#a2a2a2"}}
                                            readOnly={readOnly}
                                        >
                                            {
                                                isAdmin && showPlaceholder &&
                                                <MenuItem value={""} key={999} disabled style={{fontStyle:"italic"}}>Staff Input</MenuItem>
                                            }
                                            { selectLists.map((val, index) => (
                                                <MenuItem value={val.value} key={index}>{val.label}</MenuItem>
                                            ))}
                                        </Select>
                                    )}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                );

                case 'multiSelect1':
                    return (
                        <Grid container alignItems="center" spacing={1}>
                            <Grid item xs={12} md={small ? 4 : 3}>
                                { subsection ? (
                                    <Typography style={small ? subSection : defaultLabel}>{label}</Typography>
                                ) : (
                                    <Typography style={small ? smallLabel : defaultLabel}>{label}</Typography>
                                )}
                            </Grid>
                            <Grid item xs={12} md={small ? 7 : 8}>
                                <FormControl sx={{ width: '100%', borderRadius: '30px' }}>
                                    <Controller
                                        control={control}
                                        name={name}
                                        defaultValue={formValue}
                                        render={({
                                            field: { onChange, value }
                                        }) => (
                                            <Select
                                                className='custom-select'
                                                value={formValue}
                                                onChange={(e) => {
                                                    let val = e.target.value;
                                                    onChange(val)
                                                    onChangeVal(name, val);
                                                }}
                                                displayEmpty
                                                multiple
                                                renderValue={(selected) => {
                                                    return selected.join(', ');
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    }
                                                }}
                                                placeholder={isAdmin? "Staff Input": ""}
                                            >
                                                {selectLists.map((language) => (
                                                    <MenuItem key={language} value={language}>
                                                        <Checkbox checked={formValue.indexOf(language) > -1} />
                                                        <ListItemText primary={language} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    );

        case 'multiSelect':
            return (
                <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} md={small ? 4 : 3}>
                        { subsection ? (
                            <Typography style={small ? subSection : defaultLabel}>{label}</Typography>
                        ) : (
                            <Typography style={small ? smallLabel : defaultLabel}>{label}</Typography>
                        )}
                    </Grid>
                    <Grid item xs={12} md={small ? 7 : 8}>
                        <FormControl sx={{ width: '100%', borderRadius: '30px' }}>
                            <Select
                                className='custom-select'
                                value={formValue}
                                onChange={(e) => onChangeVal(name, e.target.value)}
                                displayEmpty
                                multiple
                                renderValue={(selected) => {
                                    return selected.join(', ');
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                      e.preventDefault();
                                    }
                                }}
                                placeholder={isAdmin? "Staff Input": ""}
                            >
                                {selectLists.map((language) => (
                                    <MenuItem key={language} value={language}>
                                        <Checkbox checked={formValue.indexOf(language) > -1} />
                                        <ListItemText primary={language} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            );

        case 'datePicker':
            return (
                <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} md={small ? 4 : 3}>
                        { subsection ? (
                            <Typography style={small ? subSection : defaultLabel}>{label}</Typography>
                        ) : (
                            <Typography style={small ? smallLabel : defaultLabel}>{label}</Typography>
                        )}
                    </Grid>
                    <Grid item xs={12} md={small ? 7 : 8}>
                        <DatePicker
                            name={name}
                            className='custom-date-picker'
                            format="DD/MM/YYYY"
                            value={(formValue != null) ? moment(formValue) : null}
                            onChange={(e) => onChangeVal(name, moment(e).format('YYYY-MM-DD'))}
                            disableFuture={disableFuture}
                            disablePast={disablePast}
                            style={{ marginBottom: '10px' }}
                            sx={{
                                '& .MuiOutlinedInput-root input': {
                                    padding: '8px 15px',
                                },
                                '& .MuiOutlinedInput-root': {
                                    marginBottom: '10px',
                                    borderRadius: '30px',
                                    marginLeft: subsection ? '16px' : '0px',
                                    fontSize: small && '12px',
                                    backgroundColor: readOnly && '#ededed',
                                },
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  e.preventDefault();
                                }
                            }}
                            readOnly={readOnly}
                        />
                    </Grid>
                </Grid>
            );

        case 'datetimePicker':
            return (
                <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} md={small ? 4 : 3}>
                        {subsection ? (
                            <Typography style={small ? subSection : defaultLabel}>{label}</Typography>
                        ) : (
                            <Typography style={small ? smallLabel : defaultLabel}>{label}</Typography>
                        )}
                    </Grid>
                    <Grid item xs={12} md={small ? 7 : 8}>
                        <DateTimePicker
                            name={name}
                            className='custom-date-picker'
                            format="DD/MM/YYYY HH:mm"
                            value={(formValue != null) ? moment(formValue) : null}
                            onChange={(e) => onChangeVal(moment(e).format('YYYY-MM-DD HH:mm'))}
                            disableFuture={disableFuture}
                            disablePast={disablePast}
                            style={{ marginBottom: '10px' }}
                            sx={{
                                '& .MuiOutlinedInput-root input': {
                                    padding: '8px 15px',
                                },
                                '& .MuiOutlinedInput-root': {
                                    marginBottom: '10px',
                                    borderRadius: '30px',
                                    marginLeft: subsection ? '16px' : '0px',
                                    fontSize: small && '12px',
                                    backgroundColor: readOnly && '#ededed',
                                },
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                }
                            }}
                            readOnly={readOnly}
                            placeholder={isAdmin? "Staff Input": ""}
                        />
                    </Grid>
                </Grid>
            );

        case 'email':
            return (
                <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} md={small ? 4 : 3}>
                        { subsection ? (
                            <Typography style={small ? subSection : defaultLabel}>{label}</Typography>
                        ) : (
                            <Typography style={small ? smallLabel : defaultLabel}>{label}</Typography>
                        )}
                    </Grid>
                    <Grid item xs={12} md={small ? 7 : 8}>
                        <Controller
                            control={control}
                            name={name}
                            defaultValue={formValue}
                            render={({
                                field: { onChange, value }
                            }) => (
                                <TextField
                                    name={name}
                                    type='email'
                                    value={value ?? ''}
                                    fullWidth
                                    variant="outlined"
                                    error={!!errors[name]}
                                    helperText={errors[name]?.message}
                                    onChange={(e) => {
                                        const email = e.target.value;
                                        onChange(e.target.value)

                                        if (!regexType.test(email)) {
                                            errors[name] = { message: 'Invalid email format' };
                                        } else {
                                            delete errors[name];
                                            onChangeVal(name, e.target.value);
                                        }
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-root input': {
                                            padding: '8px 15px',
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            marginBottom: '10px',
                                            borderRadius: '30px',
                                            marginLeft: subsection ? '16px' : '0px',
                                            fontSize: small && '12px'
                                        },
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                        e.preventDefault();
                                        }
                                    }}
                                    placeholder={isAdmin? "Staff Input": ""}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            );

        case 'signature':
            return (
                <Grid container alignItems="start" spacing={1} style={{ marginTop: '10px' }}>
                    <Grid item xs={12} sm={12} md={small ? 4 : 1.5}>
                        { subsection ? (
                            <Typography style={small ? subSection : defaultLabel}>{label}</Typography>
                        ) : (
                            <Typography style={small ? smallLabel : defaultLabel}>{label}</Typography>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4.5}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                width: '100%'
                            }}
                        >
                            <div className='signature-container'>
                                <SignatureCanvas
                                    ref={sigCanvas}
                                    penColor="black"
                                    name={name}
                                    value={formValue}
                                    backgroundColor={readOnly? "#ededed" : "#fff" }
                                    canvasProps={{
                                        height: '200px',
                                        width: '280px',
                                        className: 'sigCanvas',
                                        style: { border: '1px solid #ccc', borderRadius: '10px', backgroundColor: readOnly? "#ededed" : "#fff" },
                                    }}
                                />
                                { savedSignature ? (
                                    <FaCheckCircle className='green-check' />
                                ) : null}
                            </div>
                            <Box sx={{ marginTop: '10px' }}>
                                <button className={readOnly? "disabled-clear-btn" : "clear-btn"} onClick={(e) => clearSignature(e, name, sigCanvas)} style={{ marginRight: '10px' }} disabled={readOnly}>
                                    Clear
                                </button>
                                <button className={readOnly? "disabled-btn" : "t-accept-button"} onClick={(e) => saveSignature(e, name, sigCanvas)} disabled={readOnly}>
                                    Save
                                </button>
                            </Box>
                        </Box>
                    </Grid>
                    <SignatureImageComponent formValue={formValue} />
                </Grid>
            );

        case 'currency':
            return (
                <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={12} md={small ? 4 : 3}>
                        { subsection ? (
                            <Typography style={small ? subSection : defaultLabel}>{label}</Typography>
                        ) : (
                            <Typography style={small ? smallLabel : defaultLabel}>{label}</Typography>
                        )}
                    </Grid>
                    <Grid item xs={subsection ? 11 : 12} md={small ? 7 : 8}>
                        <Controller
                            control={control}
                            name={name}
                            defaultValue={formValue}
                            render={({
                                field: { onChange, value },
                            }) => (
                                <CurrencyInput
                                    value={value ?? ''}
                                    name={name}
                                    decimalsLimit={2}
                                    prefix="RM "
                                    onValueChange={(val) => {
                                        onChange(val);
                                        onChangeVal(name, val);
                                    }}
                                    className='custom-currency-field'
                                    style={{
                                        backgroundColor: readOnly && '#ededed', 
                                        padding: '8px 15px',
                                        ontSize: small && '12px',
                                        marginBottom: '10px',
                                        borderRadius: '30px',
                                        marginLeft: subsection ? '16px' : '0px',
                                    }}
                                    readOnly={readOnly}
                                    placeholder={isAdmin? "Staff Input" : ""}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            );

        default:
            return null;
    }
}

export default CustomTextfield